import { render, staticRenderFns } from "./BaseButtonItemList.vue?vue&type=template&id=70ca3a54&scoped=true"
import script from "./BaseButtonItemList.vue?vue&type=script&lang=js"
export * from "./BaseButtonItemList.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonItemList.vue?vue&type=style&index=0&id=70ca3a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca3a54",
  null
  
)

export default component.exports